<p class="reset-password" (click)="onResetPassword()">{{ 'Forgot password' | translate }}?</p>
